"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInput = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
} // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var getSvg = function getSvg(fillColor) {
  return "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" fill=\"".concat(fillColor, "\"><circle cx=\"8\" cy=\"8\" r=\"4\" /></svg>");
};

var StyledInput = /*#__PURE__*/_styledComponents["default"].input.withConfig({
  displayName: "indexstyles__StyledInput",
  componentId: "sc-uxw22e-0"
})(["outline:none;cursor:", ";appearance:none;width:1rem;height:1rem;border-radius:1rem;vertical-align:middle;border:1px solid ", ";:focus{border:2px solid ", ";}:checked{", " ", "}+ label{margin-left:", ";vertical-align:middle;", "}"], function (p) {
  return p.disabled ? 'auto' : 'pointer';
}, function (p) {
  return p.disabled ? p.theme.colorBackgroundChoiceDisabled : p.theme.colorBorderChoice;
}, function (p) {
  return p.theme.colorBorderChoiceFocus;
}, function (p) {
  return p.disabled ? (0, _styledComponents.css)(["background-color:", ";"], function (p) {
    return p.theme.tokens.colorBackground;
  }) : null;
}, function (p) {
  return (0, _styledComponents.css)(["background-image:url(data:image/svg+xml;base64,", ");"], btoa(getSvg(p.disabled ? p.theme.colorBackgroundChoiceDisabled : p.theme.colorBackgroundChoiceSelected)));
}, function (p) {
  return p.theme.tokens.spacing04;
}, function (p) {
  return p.disabled ? (0, _styledComponents.css)(["color:", ";"], function (p) {
    return p.theme.colorTextInputLabelDisabled;
  }) : null;
});

exports.StyledInput = StyledInput;